import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setStep } from "../../store/components/MarketExplorer.slice";

function useSetStep() {
    const dispatch = useDispatch();
    const {
        configuration: {
            buildedTargets
        }
    } = useSelector((state) => state.marketExplorer);
    useEffect(() => {
        if (!buildedTargets.length) {
            dispatch(setStep(1));
        }
    }, [buildedTargets]);
}

export default useSetStep;
